import gsap, { Circ, Cubic, Linear, Quad, Quart, Quint, Sine } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const sustainability = () => {
  const target = document.querySelector(".is-sustainability");

  if (target) {
    const bg = document.querySelectorAll('#bg .bg__img')

    const tl = gsap
      .timeline({ repeat: -1, repeatDelay: 0.8 })
      .fromTo(
        ".section-sustainability .headline .arrow",
        {
          clipPath: "inset(0% 0 100% 0)",
        },
        {
          clipPath: "inset(0% 0 0% 0)",
          ease: Quint.easeOut,
          duration: 1.0
        }
      )
      .to(".section-sustainability .headline .arrow", {
        clipPath: 'inset(100% 0 0 0)',
        ease: Cubic.easeIn,
        duration: 0.8
      }, '+=0.2');

    tl.pause()

    gsap.set(".section-sustainability .headline", {
      autoAlpha: 1,
    });


    gsap
      .timeline()
      .set("#bg .bg__img.is-show", {
        scale: 1.1,
      })
      .to("#bg .bg__img.is-show", {
        autoAlpha: 1,
        duration: 1.0,
        ease: Sine.easeInOut,
      })
      .to(
        "#bg .bg__img.is-show",
        {
          autoAlpha: 1,
          scale: 1,
          duration: 1.4,
          ease: Sine.easeOut,
        },
        "<"
      )
      .from(
        ".section-sustainability .heading > *",
        {
          autoAlpha: 0,
          y: 50,
          filter: "blur(20px)",
          duration: 0.8,
          ease: Circ.easeOut,
          stagger: {
            each: 0.24,
            ease: Circ.easeOut,
          },
          onStart: () => {
            setTimeout(() => tl.play(), 800)
          }
        },
        "<0.4"
      )


    bg.forEach((el, i) => {
      ScrollTrigger.create({
        trigger: '#' + el.getAttribute('data-id'),
        start: 'top center',
        end: 'bottom center',
        onEnter: () => {
          if (i > 0) {
            bg.forEach((el) => el.classList.remove("is-show"));
            el.classList.add("is-show");
            gsap.set(el, {
              transform: 'scale(1.1)',
            })
            gsap.to("#bg .bg__img:not(.is-show)", {
              autoAlpha: 0,
              ease: Sine.easeInOut,
              duration: 1.4,
            });
            gsap.to(el, {
              autoAlpha: 1,
              transform: 'scale(1)',
              duration: 1.4,
              // ease: Cubic.easeOut,
              ease: Sine.easeOut,
            })
          }
        },
        onEnterBack: () => {
          if (i < bg.length - 1) {
            bg.forEach((el) => el.classList.remove('is-show'))
            el.classList.add('is-show')
            gsap.set(el, {
              transform: 'scale(1.1)',
            })
            gsap.to("#bg .bg__img:not(.is-show)", {
              autoAlpha: 0,
              ease: Sine.easeInOut,
              duration: 1.4,
            });
            gsap.to(el, {
              autoAlpha: 1,
              transform: 'scale(1)',
              duration: 1.4,
              // ease: Cubic.easeOut,
              ease: Sine.easeOut,
            })
          }
        },
      })
    })

    document.querySelectorAll('.js-blurIn').forEach((el) => {
      gsap.from(el, {
        autoAlpha: 0,
        filter: 'blur(20px)',
        scrollTrigger: {
          start: 'top 75%',
          trigger: el,
        }
      })
    })

    document.querySelectorAll('.article__title').forEach((el) => {
      const char = textSplit(el.querySelector('.text'))
      
      gsap
        .timeline({
          scrollTrigger: {
            trigger: el,
            start: "top 75%",
          },
        })
        .fromTo(
          el.querySelector(".line"),
          {
            clipPath: "inset(0 100% 98% 0)",
          },
          {
            clipPath: "inset(0 0% 98% 0)",
            ease: Linear.easeNone,
            duration: 0.25,
          }
        )
        .to(
          el.querySelector(".line"),
          {
            clipPath: "inset(0 0% 0% 0)",
            ease: Quint.easeNone,
            duration: 0.6,
          }
        )
        .from(
          char,
          {
            yPercent: 100,
            stagger: 0.1,
            ease: Quint.easeOut,
            duration: 0.4,
          },
          "<-0.4"
        );
    })
  }
}

const textSplit = (el) => {
  const nodes = el.childNodes;

  let spanWrapText = "";

  nodes.forEach((node) => {
    node.nodeType === 3
      ? (spanWrapText += node.textContent.split("").reduce((prev, current) => {
          return current === " "
            ? prev + `<span class="char">&nbsp;</span>`
            : prev + `<span class="char">${current}</span>`;
        }, ""))
      : (spanWrapText += node.outerHTML);
  });

  el.innerHTML = spanWrapText

  return el.querySelectorAll(".char");
};

export default sustainability